<template>
    <div class="page-head">
        <div class="container">
            <div class="row">
                <div class="page-head-content">
                    <h1 class="page-title"><span class="orange strong">{{agency ? agency.name : ''}}</span></h1>
                </div>
            </div>
        </div>
    </div>

    <div class="content-area user-profiel"  >&nbsp;
        <div class="container">

            <div class="row" v-if="!loading && agency">
                <div class="col-lg-4">
                    <div class="card mb-4">
                        <div class="card-body text-center">
                            <img :src="agency.picture_url" :alt="agency.name" onerror="this.src='/template/assets/img/user-icon.png'" class="rounded-circle img-fluid" style="width: 150px;">
                            <h5 class="my-3">{{agency.name}}</h5>
                            <p class="text-muted mb-1" v-if="agency.created_at">{{getCreatedAt(agency.created_at)}}</p>
                            <p class="text-muted mb-4">{{agency.address}}</p>
                            <div class="d-flex justify-content-center mb-2" v-if="showJoinBtn">
                                <button type="button" class="btn btn-primary" v-on:click="joinUser">Join</button>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-4 mb-lg-0">
                        <div class="card-body p-0">
                            <ul class="list-group list-group-flush rounded-3">
                                <li class="list-group-item d-flex justify-content-between align-items-center p-3" v-if="agency.facebook">
                                    <i class="fa fa-facebook" style="color: #1096f4"></i>
                                    <a :href="agency.facebook" target="_blank"><p class="mb-0">{{agency.facebook}}</p></a>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center p-3" v-if="agency.twitter">
                                    <i class="fa fa-twitter" style="color: #1096f4;"></i>
                                    <a :href="agency.twitter" target="_blank"><p class="mb-0">{{agency.twitter}}</p></a>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center p-3" v-if="agency.google">
                                    <i class="fa fa-google" style="color: #4285f4;"></i>
                                    <a :href="agency.google" target="_blank"><p class="mb-0">{{agency.google}}</p></a>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center p-3" title="website" v-if="agency.website">
                                    <i class="fa fa-globe"></i>
                                    <a :href="agency.website" target="_blank"><p class="mb-0">{{agency.website}}</p></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="row" v-if="agency.bio">
                                <div class="col-sm-3">
                                    <p class="mb-0">Bio</p>
                                </div>
                                <div class="col-sm-9">
                                    <p class="text-muted mb-0">{{agency.bio}}</p>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <p class="mb-0">Email</p>
                                </div>
                                <div class="col-sm-9">
                                    <p class="text-muted mb-0">{{agency.email}}</p>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <p class="mb-0">Phone</p>
                                </div>
                                <div class="col-sm-9">
                                    <p class="text-muted mb-0">{{agency.phone}}</p>
                                </div>
                            </div>
                            <hr>
                            <div class="row">
                                <div class="col-sm-3">
                                    <p class="mb-0">Address</p>
                                </div>
                                <div class="col-sm-9">
                                    <p class="text-muted mb-0">{{agency.address}}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="row" v-else>
                <div class="col-md-12">
                    <div class="fa-3x">
                        <i class="fa fa-spinner fa-spin"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ref} from "vue";
import moment from "moment";
import {useRoute, useRouter} from "vue-router";
import {useAuthStore} from "../../store/auth";
import {useToast} from "vue-toastification";

export default {
    name: "AgencySingle",
    setup() {
        const route = useRoute();
        const router = useRouter();
        const toast = useToast();

        const auth = useAuthStore();

        const agencyId = route.params.id;
        const agency = ref(null);
        const loading = ref(false);
        const showJoinBtn = ref(auth.$state.user && auth.$state.user.agency_id && auth.$state.user.agency_id == agencyId ? false : true);


        const getAgencyDetail = () => {
            loading.value = true;

            window.axios.get(`/api/agency/${agencyId}`).then(response => {
                loading.value = false;

                agency.value = response.data.agency;
            }).catch(err=> {
                loading.value = false;
            });
        }

        getAgencyDetail();

        const getCreatedAt = (created_at) => {
            return moment(created_at).format('DD MMM YYYY');
        }

        const joinUser = () => {
            if(!auth.$state.signedIn) {
                router.push('/register');
                return;
            }

            if(auth.$state.user.agency_id) {
                toast.error('You already joined to another agency! You can not join to more than one agency');
                return;
            }

            window.axios.post(`/api/agency/join/${auth.$state.user.id}/${agencyId}`)
            .then((response) => {
                toast.success(response.data.message);
                showJoinBtn.value = false;
                refetchUser();
            }).catch(err => {
                toast.error(err.response.data.message);
            })
        }

        const refetchUser = () => {
            window.axios.post('/api/get-me')
            .then(response => {
                if(response.data.status == true) {
                    auth.login({signedIn: true, user: response.data.user});
                }
            }).catch(err => console.error(err));
        }

        return {
            getCreatedAt,
            agency,
            loading,
            joinUser,
            showJoinBtn
        }
    }
}
</script>
<style scoped>
.profiel-container {
    padding: 10px 5px;
}
</style>
